import api from "./api";

async function getPaymentProfiles() {
  try {
    const response = await api.get("api/paymentProfiles");
    return response.data;
  } catch (error) {
    return [];
  }
}

async function getPaymentProfileById(id) {
  try {
    const response = await api.get(`api/paymentProfiles/${id}`);
    return response.data;
  } catch (error) {
    return null;
  }
}

async function createPaymentProfile(
  name,
  isDefault,
  allowCards,
  allowOpenBanking,
  allowKlarna,
  allowAmex,
  allowBacs
) {
  try {
    const response = await api.post("api/paymentProfiles", {
      name,
      isDefault,
      allowCards,
      allowOpenBanking,
      allowKlarna,
      allowAmex,
      allowBacs,
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

async function updatePaymentProfile(
  id,
  name,
  isDefault,
  allowCards,
  allowOpenBanking,
  allowKlarna,
  allowAmex,
  allowBacs
) {
  try {
    const response = await api.put(`api/paymentProfiles/${id}`, {
      name,
      isDefault,
      allowCards,
      allowOpenBanking,
      allowKlarna,
      allowAmex,
      allowBacs,
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

async function deletePaymentProfile(id) {
  try {
    const response = await api.delete(`api/paymentProfiles/${id}`);
    return response.data;
  } catch (error) {
    return null;
  }
}

export {
  getPaymentProfiles,
  getPaymentProfileById,
  createPaymentProfile,
  updatePaymentProfile,
  deletePaymentProfile,
};
